export default __webpack_public_path__ + "static/media/download-icon.12a818d0.svg";